import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-navy py-12">
      <div className="section-container">
        <div className="flex flex-col items-center gap-6 text-center">

          {/* Full brand wordmark (logo + name + tagline) — invert filter so gold reads against dark footer */}
          <img
            src="/logo-wordmark.png"
            alt="MomentSent. Never miss a moment."
            className="w-auto h-28 object-contain"
            style={{ filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.35))' }}
          />

          {/* Links */}
          <div className="flex items-center gap-1 text-xs font-body text-white opacity-50 flex-wrap justify-center">
            <Link to="/about"    className="hover:opacity-90 transition-opacity">About</Link>
            <span className="mx-2">·</span>
            <Link to="/pricing"  className="hover:opacity-90 transition-opacity">Pricing</Link>
            <span className="mx-2">·</span>
            <Link to="/occasions" className="hover:opacity-90 transition-opacity">Occasions</Link>
            <span className="mx-2">·</span>
            <Link to="/compare"  className="hover:opacity-90 transition-opacity">Compare</Link>
            <span className="mx-2">·</span>
            <Link to="/signup"   className="hover:opacity-90 transition-opacity">Get started</Link>
            <span className="mx-2">·</span>
            <Link to="/privacy"  className="hover:opacity-90 transition-opacity">Privacy Policy</Link>
            <span className="mx-2">·</span>
            <Link to="/terms"    className="hover:opacity-90 transition-opacity">Terms of Service</Link>
            <span className="mx-2">·</span>
            <Link to="/contact"  className="hover:opacity-90 transition-opacity">Contact Us</Link>
          </div>

          {/* Fulfillment note */}
          <p className="font-body text-xs text-white opacity-40 max-w-sm leading-relaxed">
            Cards fulfilled by our print &amp; mail partners.<br className="hidden sm:block" />
            Delivered worldwide.
          </p>

          {/* Copyright */}
          <p className="font-body text-xs text-white opacity-30">
            © {new Date().getFullYear()} MomentSent LLC, Hubert, NC
          </p>

        </div>
      </div>
    </footer>
  );
}
